var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_180",
    "data-name": "Ret\\xE2ngulo 180",
    width: 80,
    height: 80,
    rx: 10,
    fill: "#d3ff9a",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Send",
    "data-name": "Iconly Two-tone Send",
    transform: "translate(18.286 18.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send-10",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke_1-143",
    "data-name": "Stroke 1-143",
    transform: "translate(11.167 11.295)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_431",
    "data-name": "Caminho 431",
    d: "M1061.766,558.1a1.715,1.715,0,0,1-2.928,1.211L1046.4,546.874a1.714,1.714,0,0,1,2.423-2.425l12.437,12.437A1.706,1.706,0,0,1,1061.766,558.1Z",
    transform: "translate(-1045.901 -543.946)",
    fill: "#d3ff9a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stroke_3-116",
    "data-name": "Stroke 3-116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_432",
    "data-name": "Caminho 432",
    d: "M1083.707,553.493a4.221,4.221,0,0,1-.171,1.193,4.277,4.277,0,0,1-1.906,2.473l-14.053,8.542-8.683,14.206a4.281,4.281,0,0,1-7.771-1.049l-9.934-34.373a4.275,4.275,0,0,1,5.353-5.291l34.1,10.194A4.278,4.278,0,0,1,1083.707,553.493Zm-39.264-10.208a.793.793,0,0,0,.037.24l9.938,34.384a.869.869,0,0,0,.382.5.85.85,0,0,0,1.164-.29l8.907-14.567a1.72,1.72,0,0,1,.571-.569l14.414-8.759a.862.862,0,0,0,.388-.5.837.837,0,0,0-.071-.647.846.846,0,0,0-.505-.4l-34.121-10.2a.813.813,0,0,0-.489-.007A.853.853,0,0,0,1044.443,543.285Z",
    transform: "translate(-1041.016 -539.005)",
    fill: "#d3ff9a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.b0acfb39b8b5fff751fbb3910e6f5c23.svg";
export { ForwardRef as ReactComponent };